import { colors, Divider, LayoutBand, Separator } from '@fs/zion-ui'
import React from 'react'
import { MERGE_LAYOUT_MARGIN } from '../../merge-common/helpers'

export default function OneMergePageFirstSeparator(): JSX.Element {
  return (
    <>
      <Divider />
      <LayoutBand marginX={MERGE_LAYOUT_MARGIN}>
        <LayoutBand color={colors.gray00}>
          <Separator size={MERGE_LAYOUT_MARGIN} />
        </LayoutBand>
      </LayoutBand>
    </>
  )
}
